import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export const downloadDealDetailPDF = async () => {
  const element = document.getElementById('deal-detail-container');
  if (!element) return;

  await document.fonts.ready;

  const linksData = [];
  const securityIcons = element.getElementsByClassName('security-measure-card');
  Array.from(securityIcons).forEach((icon) => {
    const card = icon.parentElement;
    if (card) {
      const btn = card.querySelector('button');
      if (btn && btn.textContent.trim().toLowerCase() === 'read more') btn.click();
    }
  });

  await new Promise((r) => setTimeout(r, 400));

  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    backgroundColor: '#ffffff',
    allowTaint: false,

    onclone: (clonedDoc) => {
      const infoText = clonedDoc.getElementById('deat-details-info-text');
      const dealDetailForm = clonedDoc.getElementById('deal-detail-form');
      const readMoreButton = clonedDoc.getElementById('read-more-button');
      const multiTag = clonedDoc.getElementById('multi-tag');
      const securityMeasureCardIcons = clonedDoc.getElementsByClassName('security-measure-card');
      const companyListItem = clonedDoc.querySelectorAll('#deal-detail-company-list-item');

      if (infoText) {
        infoText.style.marginBottom = '22px';
        infoText.style.marginTop = '10px';
      }
      if (dealDetailForm) dealDetailForm.style.marginTop = '48px';
      if (readMoreButton) readMoreButton.style.display = 'none';
      if (multiTag) {
        multiTag.style.marginTop = '13px';
        multiTag.style.paddingBottom = '13px';
      }
      Array.from(securityMeasureCardIcons).forEach((iconEl) => {
        const card = iconEl.parentElement;
        if (card) {
          const btn = card.querySelector('button');
          if (btn) btn.style.display = 'none';
        }
        iconEl.style.cssText =
          'width:32px; height:32px; display:flex; align-items:center; justify-content:center;';
        const svg = iconEl.querySelector('svg');
        if (svg) {
          svg.setAttribute('width', '10');
          svg.setAttribute('height', '10');
        }
      });
      Array.from(companyListItem).forEach((item) => {
        item.style.paddingBottom = '14px';
      });

      const docContainer = clonedDoc.getElementById('deal-detail-documents');
      const containerRect = clonedDoc
        .getElementById('deal-detail-container')
        .getBoundingClientRect();

      if (docContainer) {
        const anchors = docContainer.querySelectorAll('a');
        anchors.forEach((a) => {
          const rect = a.getBoundingClientRect();
          linksData.push({
            url: a.href,
            x: rect.left - containerRect.left,
            y: rect.top - containerRect.top,
            w: rect.width,
            h: rect.height,
          });
        });
      }
    },
    ignoreElements: (el) => el.hasAttribute('data-html2canvas-ignore'),
  });

  const pdf = new jsPDF('p', 'mm', 'a4');
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = pdf.internal.pageSize.getHeight();
  const ratio = pdfWidth / (canvas.width / 2);
  const imgHeight = (canvas.height * pdfWidth) / canvas.width;

  let heightLeft = imgHeight;
  let position = 0;
  const imgData = canvas.toDataURL('image/png');

  pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, imgHeight);
  heightLeft -= pdfHeight;

  while (heightLeft > 0) {
    position -= pdfHeight;
    pdf.addPage();
    pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, imgHeight);
    heightLeft -= pdfHeight;
  }

  linksData.forEach((link) => {
    const xMM = link.x * ratio;
    const yMM = link.y * ratio;
    const wMM = link.w * ratio;
    const hMM = link.h * ratio;

    const pageIndex = Math.floor(yMM / pdfHeight) + 1;
    const yOnPage = yMM % pdfHeight;

    if (pageIndex <= pdf.internal.getNumberOfPages()) {
      pdf.setPage(pageIndex);
      pdf.link(xMM, yOnPage, wMM, hMM, { url: link.url });
    }
  });

  pdf.save('deal-details.pdf');
};
